import { render, staticRenderFns } from "./AllocationSummaryCard.vue?vue&type=template&id=915db9ca&"
import script from "./AllocationSummaryCard.vue?vue&type=script&lang=js&"
export * from "./AllocationSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports